import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import { useQuery } from 'libs/query'
import { useParams } from 'libs/router'
import { useContext } from 'react'
import { useAxiosPrivate } from 'shared/hooks'
import { HistoryRes } from 'shared/types/general.types'
import { AuthContext } from 'store'

export const useFetchBookingHistory = () => {
	const axiosPrivate = useAxiosPrivate()
	const params = useParams()
	const { auth } = useContext(AuthContext)

	const { data: bookingHistory, isPending: isBookingHistoryLoading } = useQuery<HistoryRes>({
		queryKey: queryKeys.bookings.history(params.id as string),
		queryFn: () => axiosPrivate.get(apiRoutes.bookingHistory(params.id as string)),
		enabled: !!auth.accessToken
	})

	return { bookingHistory, isBookingHistoryLoading }
}
